export default "__VITE_ASSET__852f6c6b__"